import React, { Component } from 'react';
import CountdownTimer from './CountdownTimer';
import { Utils } from '../../utils/Utils';
import { ReplayAction } from './ReplayActionBuilder';

window.actionID;

// let rangeSize = 50; //感应范围容错大小，越大越容易拖进框内

/**
 * cid=1_2_3&page=16    翻牌游戏
 */

class FlipFlopGameInteraction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prevImage: "",  //上一次点击的图片
            prevIndex: -1,  //上一次点击的图片序号
            cards: props.item.detail.cards || [],
            drawRightTotal: 0,  //选对的总数量
            showStatus: 0,   //1-全部翻答案；2-全部翻一样面
            canClick: false,    //可以进行翻牌操作
            mainSize: { //显示区的宽高
                width: 690,
                height: 518
            },
        };
        this.replayKeyNum = 2;  //录屏的key，默认有一个 begin和feedback，因此默认是2，每次调用一下ReplayAction.add，就加1
        this.cid = Utils.getHashQueryString("cid");
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.uuid = Utils.getCookie('uuid') || 0;
        this.roundNum = 1;  // 第几轮
        this.startWorkTime = new Date().getTime();  // 开始时间，用来计算完成这个模板使用的时间，用于算给积分
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currStarCount: nextProps.currStarCount,
            currSubjectCount: nextProps.currSubjectCount,
        })
    }

    componentDidMount() {
        const that = this;
        let content_size = {};
        let content_course = document.getElementById('content_course');
        content_size.width = content_course.clientWidth;
        content_size.height = content_course.clientHeight;
        that.setState({
            mainSize: content_size
        });
        that.startWorkTime = new Date().getTime();
        setTimeout(() => {
            //录屏相关代码
            if (window.needRecoRecordCourse) {
                if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                    ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                }
                ReplayAction.add(window.keyStr, 'PURBLE_REPLAY_BEGIN', (new Date().getTime() - window.recordPageTime), JSON.stringify({
                    "count": 60
                }));
            }
        }, 0);
        setTimeout(() => {
            that.setState({
                showStatus: 1
            });
        }, 1000);
        setTimeout(() => {
            that.setState({
                showStatus: 2
            });
        }, 3000);
        setTimeout(() => {
            that.setState({
                canClick: true
            });
        }, 4000);
    }

    handleFlipFlop(e, index, image, audio, id) {    //index-编号
        const that = this;
        const { item, isReview } = this.props;
        const { prevImage, prevIndex, drawRightTotal, mainSize } = this.state;
        const feedbacks = item.detail.feedbacks;
        const matchAudio = isReview ? document.getElementById('playClickAudio') : document.getElementById('matchAudio');
        const flipWrap = document.getElementsByClassName('flip_wrap');

        const event = e || window.event;
        event.preventDefault();
        event.stopPropagation();
        /*事件源对象兼容*/
        let target = event.target || event.srcElement;

        if (target.nodeName.toLocaleLowerCase() === 'img') {
            target = target.parentNode;
        }

        if (audio) {
            matchAudio.setAttribute('src', window.resourceUrl + 'audio/' + audio); //播放声音

            if (isReview) {
                const playClickAudioPromise = matchAudio.play();
                if (playClickAudioPromise !== undefined) {
                    playClickAudioPromise.then(_ => {
                        // console.log('===play', _)
                    }).catch(error => {
                        // console.log('===noplay', error)
                    });
                }
            }
        }

        if (target.className.indexOf('flip-flop') === -1) {
            flipWrap[index].setAttribute('class', 'flip_wrap flip-flop');
            if (prevImage === "" && index !== prevIndex) {  //点击第一张图
                that.setState({
                    prevImage: image,
                    prevIndex: index
                });
            } else if (prevImage === image) {   //选择两个相同
                that.setState({
                    prevImage: "",
                    prevIndex: -1,
                    drawRightTotal: drawRightTotal + 1,
                    canClick: isReview ? true : false
                }, () => {
                    //防止快速点击翻牌，同时翻很多
                    setTimeout(() => {
                        that.setState({
                            canClick: true
                        });
                    }, 1000);

                    //对的个数等于正确的总数
                    if (!audio && (drawRightTotal + 1 === item.detail.cards.length / 2) && !isReview) {
                        setTimeout(() => {
                            that.handleComplate(feedbacks.succ);
                        }, 500);
                    }
                });
            } else {
                that.setState({
                    prevImage: "",
                    prevIndex: -1,
                    canClick: isReview ? true : false
                }, () => {
                    setTimeout(() => {
                        flipWrap[index].setAttribute('class', 'flip_wrap flip-back');
                        flipWrap[prevIndex].setAttribute('class', 'flip_wrap flip-back');
                    }, 2000);
                    //防止快速点击翻牌，同时翻很多
                    setTimeout(() => {
                        that.setState({
                            canClick: true
                        });
                    }, 3000);
                });
            }
        }

        //录屏相关代码
        if (window.needRecoRecordCourse) {
            const content_course = document.getElementById('content_course');
            const parent_top = Utils.getElementOffsetTop(content_course);
            const parent_left = Utils.getElementOffsetLeft(content_course);
            console.log(event.pageY - parent_top, event.pageX - parent_left)
            ReplayAction.add(window.keyStr, 'PURBLE_REPLAY_TAP', (new Date().getTime() - window.recordPageTime), JSON.stringify({
                "tapPoint": {
                    "x": (event.pageX - parent_left) / mainSize.width,
                    "y": (event.pageY - parent_top) / mainSize.height
                },
                "id": id
            }));
            that.replayKeyNum++;
        }

    }

    handleComplate(feedback) {
        const that = this;
        const { item, childCallback, isReview } = this.props;
        const { currStarCount, currSubjectCount } = this.state;
        const judgeFunction = item.detail.judgeFunction;
        const timeout = item.detail && item.detail.feedbacks && item.detail.feedbacks.timeout ? item.detail.feedbacks.timeout : null;
        let type = "";
        let info = "";
        if (!isReview) {
            if (feedback) {
                if (feedback.type) {
                    type = feedback.type;
                }
                if (feedback.info) {
                    info = feedback.info;
                }
            } else {
                type = timeout ? timeout.type : "";
                info = timeout ? timeout.info : "";
            }
            if (judgeFunction) {
                let returnScore = JSON.parse(window[judgeFunction](
                    item.actionID,
                    type,
                    info,
                    currStarCount,
                    currSubjectCount,
                ));

                if (returnScore && returnScore.resultInfo && returnScore.timeline) {
                    if (typeof childCallback === 'function') {
                        if (window.needRecoRecordCourse) {
                            ReplayAction.add(window.keyStr, 'PURBLE_REPLAY_FEEDBACK', (new Date().getTime() - window.recordPageTime), JSON.stringify(returnScore));
                            ReplayAction.commit(window.keyStr, 'FlipFlopGameInteraction_');
                            window.keyStr += `.detail.timeline.nodes[${that.replayKeyNum}].actions[0]`;

                            childCallback(returnScore, ReplayAction.getScene());

                            ReplayAction.cleanScene();
                        } else {
                            childCallback(returnScore);
                        }
                    }
                }
            }

            //上报学习报告
            if (that.cid) {
                // Utils.reportRecord(window.startTime, item.actionID, item.actionType, type, 0, item.knowledge);
                if (item.actionID === window.actionID) {
                    that.roundNum++;
                } else {
                    that.roundNum = 1;
                }
                window.actionID = item.actionID;
                Utils.newReportRecord({
                    "cid": that.cid,
                    "startTime": window.startTime,
                    "actionId": item.actionID,
                    "actionType": item.actionType,
                    "fbType": type,   //fbType,
                    "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                    "score": 0,
                    "pageNum": window.curPageToReport || 0,
                }, {
                    "knowledge": item.knowledge
                });

                // 给积分
                Utils.giveIntegrals(2, {
                    totalTime: timeout ? timeout.time : 60,
                    useTime: (new Date().getTime() - that.startWorkTime) / 1000,
                    roundNum: that.roundNum,
                    fbType: type
                });

                // 勋章上报
                Utils.encourageRecord({
                    "cid": that.cid,
                    "startTime": window.startTime,
                    "actionId": item.actionID,
                    "actionType": item.actionType,
                    "fbType": type,   //fbType,
                    "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                    "score": 0,
                    "pageNum": window.curPageToReport || 0,
                    "integrals": window.curIntegrals,
                });
            }
        }
    }

    //处理 AudioMutiMatchGameInteraction_ 音频播放完成
    handleEndedAudio() {
        const that = this;
        const { item } = this.props;
        const { drawRightTotal, isReview } = this.state;
        const feedbacks = item.detail.feedbacks;

        //对的个数等于正确的总数
        if (drawRightTotal === item.detail.cards.length / 2 && !isReview) {
            setTimeout(() => {
                that.handleComplate(feedbacks.succ);
            }, 500);
        }
    }

    render() {
        const that = this;
        const { item } = this.props;
        const { drawRightTotal, showStatus, canClick } = this.state;
        return (
            <div id="flipFlop" className="flip-game">
                {
                    drawRightTotal !== item.detail.matchRules.length && item.detail.feedbacks ?
                        <CountdownTimer feedbacks={item.detail.feedbacks} complateCallback={that.handleComplate.bind(that)} />
                        : null
                }
                {
                    item && item.detail.cards && item.detail.cards.map((card, index) => {
                        return (
                            <div key={index} id={card.id} className={showStatus === 1 ? "flip_wrap flip-flop" : showStatus === 2 ? "flip_wrap flip-back" : "flip_wrap"} style={{
                                "position": "absolute",
                                "top": card.pos.y * 100 + "%",
                                "left": card.pos.x * 100 + "%",
                                "width": card.size.width / 2 * window.mainSize.percent + "px",
                                "height": card.size.height / 2 * window.mainSize.percent + "px",
                            }} onClick={(e) => canClick ? that.handleFlipFlop(e, index, card.image, card.audio, card.id) : null}>
                                <img alt="" src={window.resourceUrl + card.image} style={{
                                    "position": "absolute",
                                    "top": 0,
                                    "left": 0,
                                    "width": card.size.width / 2 * window.mainSize.percent + "px",
                                    "height": card.size.height / 2 * window.mainSize.percent + "px",
                                }} /*onError={() => that.handleImgError(showPageNode.detail.resourceID)}*/ />
                                <img alt="" src={window.resourceUrl + card.back_image} style={{
                                    "position": "absolute",
                                    "top": 0,
                                    "left": 0,
                                    "width": card.size.width / 2 * window.mainSize.percent + "px",
                                    "height": card.size.height / 2 * window.mainSize.percent + "px",
                                }} /*onError={() => that.handleImgError(showPageNode.detail.resourceID)}*/ />
                            </div>
                        )
                    })
                }
                <audio id="matchAudio" src="" autoPlay onEnded={() => that.handleEndedAudio()} />
            </div>
        );
    }
}

export default FlipFlopGameInteraction;



// WEBPACK FOOTER //
// ./src/components/on/FlipFlopGameInteraction.js